import {
  CeIconActiveDark,
  CeIconActive,
  CeIconAddCircle,
  CeIconAdd,
  CeIconAlert,
  CeIconAmazon,
  CeIconApi,
  CeIconArrayType,
  CeIconArray,
  CeIconArrowDownCircle,
  CeIconArrowDown,
  CeIconArrowExportCircle,
  CeIconArrowExport,
  CeIconArrowLeftCircle,
  CeIconArrowLeft,
  CeIconArrowRightCircle,
  CeIconArrowRight,
  CeIconArrowUpCircle,
  CeIconArrowUp,
  CeIconArrowUpDownCircle,
  CeIconArrowUpDown,
  CeIconAttach,
  CeIconBalance,
  CeIconBank,
  CeIconBarGraph,
  CeIconBeta,
  CeIconBlock,
  CeIconBold,
  CeIconBoxWithCheck,
  CeIconBox,
  CeIconBusiness,
  CeIconCalendar,
  CeIconCall,
  CeIconCamera,
  CeIconCancelCircle,
  CeIconCancel,
  CeIconCard,
  CeIconCaretDown,
  CeIconCaretLeft,
  CeIconCaretRight,
  CeIconCaretUp,
  CeIconCartIcon,
  CeIconCart,
  CeIconCertificate,
  CeIconChangeCircle,
  CeIconChange,
  CeIconChannel,
  CeIconCharge,
  CeIconChat,
  CeIconCheckCircle,
  CeIconCheckDark,
  CeIconCheck,
  CeIconChevronDownCircle,
  CeIconChevronDown,
  CeIconChevronLeftCircle,
  CeIconChevronLeft,
  CeIconChevronRightCircle,
  CeIconChevronRight,
  CeIconChevronUpCircle,
  CeIconChevronUp,
  CeIconClipboard,
  CeIconClock,
  CeIconCode,
  CeIconConvertDark,
  CeIconConvert,
  CeIconCouponIcon,
  CeIconCoupon,
  CeIconCustomer,
  CeIconDarkTheme,
  CeIconDataTypes,
  CeIconDatabase,
  CeIconDelete,
  CeIconDisputeProtection,
  CeIconDocument,
  CeIconDot,
  CeIconDownArrow,
  CeIconDownload,
  CeIconDragDrop,
  CeIconDrugDocument,
  CeIconDuplicate,
  CeIconEditCircle,
  CeIconEdit,
  CeIconEmail,
  CeIconEmoji,
  CeIconEvent,
  CeIconExternal,
  CeIconFacebookLogo,
  CeIconFacebook,
  CeIconFee,
  CeIconFilterIcon,
  CeIconFilter,
  CeIconFlag,
  CeIconFluentDocumentPageNumber24Filled,
  CeIconGitHubLogo,
  CeIconGithub,
  CeIconGlobe,
  CeIconGoogle,
  CeIconGuide,
  CeIconHastag,
  CeIconHelp,
  CeIconHide,
  CeIconHome,
  CeIconHorizontalConvert,
  CeIconHover,
  CeIconIcBaselineRemoveRedEye,
  CeIconImport,
  CeIconInactiveCheck,
  CeIconInactiveDark,
  CeIconInactive,
  CeIconInfoDark,
  CeIconInfo,
  CeIconIntermideateDark,
  CeIconIntermideate,
  CeIconInvoice,
  CeIconItalic,
  CeIconJamAlarmClockF,
  CeIconJamAlertF,
  CeIconJamAlignCenter,
  CeIconJamAlignLeft,
  CeIconJamAlignRight,
  CeIconJamBranchF,
  CeIconJamCheck,
  CeIconJamComputerAlt,
  CeIconJamDownload,
  CeIconJamFilesF,
  CeIconJamHashtag,
  CeIconJamHistory,
  CeIconJamMoonF,
  CeIconJamPadlockF,
  CeIconJamPaused,
  CeIconJamPhone,
  CeIconJamSaveF,
  CeIconJamStarF,
  CeIconJamStar,
  CeIconJamSunF,
  CeIconJamTrashAltF,
  CeIconJamUnsplash,
  CeIconJamWhatsapp,
  CeIconLight,
  CeIconLineChart,
  CeIconCumulativeChart,
  CeIconList,
  CeIconLoader,
  CeIconLocation,
  CeIconLock,
  CeIconLogoOld,
  CeIconLogo,
  CeIconLogosFacebookMessenger,
  CeIconLogosGoogleIcon,
  CeIconLogosAmazon,
  CeIconLogosBigc,
  CeIconLogosShopify,
  CeIconLogosWhatsapp,
  CeIconLogosWix,
  CeIconLogosWoo,
  CeIconMicrosoftLogo,
  CeIconMicrosoft,
  CeIconMingcuteTextFill,
  CeIconMoreCircle,
  CeIconMore,
  CeIconMultiple1,
  CeIconMultiple2,
  CeIconMultiple,
  CeIconNegativeCircle,
  CeIconNegative,
  CeIconNote,
  CeIconNotifications,
  CeIconNumber,
  CeIconOrder,
  CeIconPanelArrowLeft,
  CeIconPanelArrowRight,
  CeIconPaperclip,
  CeIconPause,
  CeIconPaymentLinks,
  CeIconPercentage,
  CeIconPerformance,
  CeIconPersonAlert,
  CeIconPerson,
  CeIconPin,
  CeIconPlan,
  CeIconPlane,
  CeIconPlayCircle,
  CeIconPlay,
  CeIconProduct,
  CeIconRadioDark,
  CeIconRecurringInvoice,
  CeIconRefreshCircle,
  CeIconRefresh,
  CeIconRefundCircle,
  CeIconRefundIcon,
  CeIconRefund,
  CeIconReporting,
  CeIconReserve,
  CeIconReview,
  CeIconRisk,
  CeIconRule,
  CeIconSave,
  CeIconSearch,
  CeIconSend,
  CeIconSettings,
  CeIconShopify,
  CeIconSigned,
  CeIconSoundOff,
  CeIconSoundOn,
  CeIconSparkle,
  CeIconSpinner,
  CeIconStaricon,
  CeIconStore,
  CeIconStringText,
  CeIconString,
  CeIconSubscription,
  CeIconSuccess,
  CeIconSupport,
  CeIconTablerPercentage,
  CeIconTasks,
  CeIconTerminal,
  CeIconTransaction,
  CeIconTransfer,
  CeIconTrash,
  CeIconTrial,
  CeIconTruck,
  CeIconType,
  CeIconUnderline,
  CeIconUsage,
  CeIconVerified,
  CeIconVideo,
  CeIconWallet,
  CeIconWarehouse,
  CeIconWarningCircle,
  CeIconWarningInfo,
  CeIconWarning,
  CeIconWebhook,
  CeIconWeldone,
  CeIconWhatsapp,
  CeIconWithdrawal,
  CeIconIncomingPayment,
  CeIconOpenFolder,
  CeIconCloseFolder,
  CeIconObject,
  CeiconBoolean,
  CeiconEvent,
  CeiconPage,
  CeiconTool,
  CeiconUnlock,
  CeIconInventory,
} from './ce-icon.model';

export const all_icons = [
  CeIconActiveDark,
  CeIconActive,
  CeIconAddCircle,
  CeIconAdd,
  CeIconAlert,
  CeIconAmazon,
  CeIconApi,
  CeIconArrayType,
  CeIconArray,
  CeIconArrowDownCircle,
  CeIconArrowDown,
  CeIconArrowExportCircle,
  CeIconArrowExport,
  CeIconArrowLeftCircle,
  CeIconArrowLeft,
  CeIconArrowRightCircle,
  CeIconArrowRight,
  CeIconArrowUpCircle,
  CeIconArrowUp,
  CeIconArrowUpDownCircle,
  CeIconArrowUpDown,
  CeIconAttach,
  CeIconBalance,
  CeIconBank,
  CeIconBarGraph,
  CeIconBeta,
  CeIconBlock,
  CeIconBold,
  CeIconBoxWithCheck,
  CeIconBox,
  CeIconBusiness,
  CeIconCalendar,
  CeIconCall,
  CeIconCamera,
  CeIconCancelCircle,
  CeIconCancel,
  CeIconCard,
  CeIconCaretDown,
  CeIconCaretLeft,
  CeIconCaretRight,
  CeIconCaretUp,
  CeIconCartIcon,
  CeIconCart,
  CeIconCertificate,
  CeIconChangeCircle,
  CeIconChange,
  CeIconChannel,
  CeIconCharge,
  CeIconChat,
  CeIconCheckCircle,
  CeIconCheckDark,
  CeIconCheck,
  CeIconChevronDownCircle,
  CeIconChevronDown,
  CeIconChevronLeftCircle,
  CeIconChevronLeft,
  CeIconChevronRightCircle,
  CeIconChevronRight,
  CeIconChevronUpCircle,
  CeIconChevronUp,
  CeIconClipboard,
  CeIconClock,
  CeIconCode,
  CeIconConvertDark,
  CeIconConvert,
  CeIconCouponIcon,
  CeIconCoupon,
  CeIconCustomer,
  CeIconDarkTheme,
  CeIconDataTypes,
  CeIconDatabase,
  CeIconDelete,
  CeIconDisputeProtection,
  CeIconDocument,
  CeIconDot,
  CeIconDownArrow,
  CeIconDownload,
  CeIconDragDrop,
  CeIconDrugDocument,
  CeIconDuplicate,
  CeIconEditCircle,
  CeIconEdit,
  CeIconEmail,
  CeIconEmoji,
  CeIconEvent,
  CeIconExternal,
  CeIconFacebookLogo,
  CeIconFacebook,
  CeIconFee,
  CeIconFilterIcon,
  CeIconFilter,
  CeIconFlag,
  CeIconFluentDocumentPageNumber24Filled,
  CeIconGitHubLogo,
  CeIconGithub,
  CeIconGlobe,
  CeIconGoogle,
  CeIconGuide,
  CeIconHastag,
  CeIconHelp,
  CeIconHide,
  CeIconHome,
  CeIconHorizontalConvert,
  CeIconHover,
  CeIconIcBaselineRemoveRedEye,
  CeIconImport,
  CeIconInactiveCheck,
  CeIconInactiveDark,
  CeIconInactive,
  CeIconInfoDark,
  CeIconInfo,
  CeIconIntermideateDark,
  CeIconIntermideate,
  CeIconInvoice,
  CeIconItalic,
  CeIconJamAlarmClockF,
  CeIconJamAlertF,
  CeIconJamAlignCenter,
  CeIconJamAlignLeft,
  CeIconJamAlignRight,
  CeIconJamBranchF,
  CeIconJamCheck,
  CeIconJamComputerAlt,
  CeIconJamDownload,
  CeIconJamFilesF,
  CeIconJamHashtag,
  CeIconJamHistory,
  CeIconJamMoonF,
  CeIconJamPadlockF,
  CeIconJamPaused,
  CeIconJamPhone,
  CeIconJamSaveF,
  CeIconJamStarF,
  CeIconJamStar,
  CeIconJamSunF,
  CeIconJamTrashAltF,
  CeIconJamUnsplash,
  CeIconJamWhatsapp,
  CeIconLight,
  CeIconLineChart,
  CeIconCumulativeChart,
  CeIconList,
  CeIconLoader,
  CeIconLocation,
  CeIconLock,
  CeIconLogoOld,
  CeIconLogo,
  CeIconLogosFacebookMessenger,
  CeIconLogosGoogleIcon,
  CeIconLogosAmazon,
  CeIconLogosBigc,
  CeIconLogosShopify,
  CeIconLogosWhatsapp,
  CeIconLogosWix,
  CeIconLogosWoo,
  CeIconMicrosoftLogo,
  CeIconMicrosoft,
  CeIconMingcuteTextFill,
  CeIconMoreCircle,
  CeIconMore,
  CeIconMultiple1,
  CeIconMultiple2,
  CeIconMultiple,
  CeIconNegativeCircle,
  CeIconNegative,
  CeIconNote,
  CeIconNotifications,
  CeIconNumber,
  CeIconOrder,
  CeIconPanelArrowLeft,
  CeIconPanelArrowRight,
  CeIconPaperclip,
  CeIconPause,
  CeIconPaymentLinks,
  CeIconPercentage,
  CeIconPerformance,
  CeIconPersonAlert,
  CeIconPerson,
  CeIconPin,
  CeIconPlan,
  CeIconPlane,
  CeIconPlayCircle,
  CeIconPlay,
  CeIconProduct,
  CeIconRadioDark,
  CeIconRecurringInvoice,
  CeIconRefreshCircle,
  CeIconRefresh,
  CeIconRefundCircle,
  CeIconRefundIcon,
  CeIconRefund,
  CeIconReporting,
  CeIconReserve,
  CeIconReview,
  CeIconRisk,
  CeIconRule,
  CeIconSave,
  CeIconSearch,
  CeIconSend,
  CeIconSettings,
  CeIconShopify,
  CeIconSigned,
  CeIconSoundOff,
  CeIconSoundOn,
  CeIconSparkle,
  CeIconSpinner,
  CeIconStaricon,
  CeIconStore,
  CeIconStringText,
  CeIconString,
  CeIconSubscription,
  CeIconSuccess,
  CeIconSupport,
  CeIconTablerPercentage,
  CeIconTasks,
  CeIconTerminal,
  CeIconTransaction,
  CeIconTransfer,
  CeIconTrash,
  CeIconTrial,
  CeIconTruck,
  CeIconType,
  CeIconUnderline,
  CeIconUsage,
  CeIconVerified,
  CeIconVideo,
  CeIconWallet,
  CeIconWarehouse,
  CeIconWarningCircle,
  CeIconWarningInfo,
  CeIconWarning,
  CeIconWebhook,
  CeIconWeldone,
  CeIconWhatsapp,
  CeIconWithdrawal,
  CeIconIncomingPayment,
  CeIconOpenFolder,
  CeIconCloseFolder,
  CeIconObject,
  CeiconBoolean,
  CeiconEvent,
  CeiconPage,
  CeiconTool,
  CeiconUnlock,
  CeIconInventory,
];
